module.exports = __webpack_public_path__ + "img/title-bg.b1ebb54e.png";